import { EmailField, PhoneField } from '@/components/shared';
import { REQUIRED_RULE, VALIDATION_MESSAGES } from '@/constants/form-validation';
import { Col, Form, Row, Select, Switch } from 'antd';

import { USER_ROLES } from '@/constants/user-management';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountInfoSectionProps } from './types';

const { Option } = Select;

const AccountInfoSection: FC<AccountInfoSectionProps> = ({ editingUser }) => {
	const { t } = useTranslation('components');

	return (
		<>
			<Row gutter={16}>
				<Col span={12}>
					<EmailField disabled={!!editingUser} placeholder={t('forms.userForm.emailPlaceholder')} />
				</Col>
				<Col span={12}>
					<PhoneField required={false} placeholder={t('forms.userForm.phonePlaceholder')} />
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={12}>
					<Form.Item
						name='role'
						label={t('forms.userForm.role')}
						rules={[REQUIRED_RULE(VALIDATION_MESSAGES.ROLE_REQUIRED)]}
					>
						<Select placeholder={t('forms.userForm.selectRolePlaceholder')}>
							<Option value={USER_ROLES.SUPER_ADMIN}>Super Admin</Option>
							<Option value={USER_ROLES.CONTENT_MANAGER}>Content Manager</Option>
							<Option value={USER_ROLES.SUPPORT}>Support</Option>
							<Option value={USER_ROLES.ANALYST}>Analyst</Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name='isActive'
						label={t('forms.userForm.accountStatus')}
						valuePropName='checked'
					>
						<Switch
							checkedChildren={t('forms.userForm.active')}
							unCheckedChildren={t('forms.userForm.inactive')}
						/>
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={12}>
					<Form.Item
						name='isEmailVerified'
						label={t('forms.userForm.emailVerification')}
						valuePropName='checked'
					>
						<Switch
							checkedChildren={t('forms.userForm.verified')}
							unCheckedChildren={t('forms.userForm.unverified')}
						/>
					</Form.Item>
				</Col>
			</Row>
		</>
	);
};

export { AccountInfoSection };
export default AccountInfoSection;
